import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.boundCloseOnEscape = this.closeOnEscape.bind(this);
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this);

    document.addEventListener("keydown", this.boundCloseOnEscape);
    document.addEventListener("click", this.boundCloseOnClickOutside);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundCloseOnEscape);
    document.removeEventListener("click", this.boundCloseOnClickOutside);
  }

  toggle(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    let closestTabContent = event.target.closest(".tabcontent");

    if (!closestTabContent) {
      console.error("Aucun élément .tabcontent trouvé !");
      return;
    }

    let sidebar = closestTabContent.querySelector(".fx-hm-sidebar");

    if (!sidebar) {
      console.error("Aucun sidebar trouvé dans ce tabcontent !");
      return;
    }

    let isOpened = sidebar.style.width && sidebar.style.width !== "0px";

    if (isOpened) {
      this.closeNav(sidebar);
    } else {
      this.openNav(sidebar);
    }
  }

  openNav(sidebar) {
    sidebar.style.display = "block";
    sidebar.style.opacity = "0"; // Début de l'effet de fondu
    sidebar.style.width = "300px";
    sidebar.style.right = "0px";
    sidebar.style.top = "auto";

    // Animation fluide pour l'opacité
    setTimeout(() => {
      sidebar.style.transition = "opacity 0.3s ease-in-out, width 0.3s ease-in-out";
      sidebar.style.opacity = "1";
    }, 10);
  }

  closeNav(sidebar) {
    sidebar.style.opacity = "0"; // Ajoute un fondu progressif
    sidebar.style.transition = "opacity 0.3s ease-in-out, width 0.3s ease-in-out";

    setTimeout(() => {
      sidebar.style.width = "0px";
    }, 50); // Légère attente pour commencer la réduction de largeur

    setTimeout(() => {
      sidebar.style.display = "none"; // Cache après l'animation
    }, 300);
  }

  // Cherche un sidebar actuellement ouvert n'importe où sur la page. On ne se fie pas
  // à un état stocké sur l'instance (this.sidebar/this.isOpened) car chaque hm avec
  // has_sidebar:true instancie son propre controller "sidebar" : l'instance qui reçoit
  // l'action toggle n'est pas forcément celle qui reçoit l'évènement keydown/click.
  findOpenSidebar() {
    return Array.from(document.querySelectorAll(".fx-hm-sidebar")).find(
      (sidebar) => sidebar.style.width && sidebar.style.width !== "0px",
    );
  }

  closeOnClickOutside(event) {
    let sidebar = this.findOpenSidebar();
    if (sidebar && !sidebar.contains(event.target) && !event.target.closest(".fx-hm-sidebar-toggle")) {
      this.closeNav(sidebar);
    }
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return;
    let sidebar = this.findOpenSidebar();
    if (sidebar) {
      this.closeNav(sidebar);
    }
  }
}
